// DoneActions.tsx
import CommonButtons from "../../../../../shared/components/CommonButtons";
import Print from "../../../../../print-configuration/PrintConfigration";

interface Props {
  onSendMail: () => void;
  onSendMessage: () => void;
  onDone: () => void;
  printData: any;
  osb: number | string;
  disabled?: boolean; // new prop
  order: any
}

export default function DoneActions({ onSendMail, onSendMessage, onDone, printData, osb, disabled = false, order }: Props) {
  if (!order) {
    return (
      <div className="flex h-auto w-full items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="flex gap-2">
            <span className="h-3 w-3 animate-bounce rounded-full bg-blue-600"></span>
            <span
              className="h-3 w-3 animate-bounce rounded-full bg-blue-600"
              style={{ animationDelay: "0.15s" }}
            ></span>
            <span
              className="h-3 w-3 animate-bounce rounded-full bg-blue-600"
              style={{ animationDelay: "0.3s" }}
            ></span>
          </div>

          <p className="text-lg font-medium text-gray-700 animate-pulse">
            Please wait, loading order data...
          </p>
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-center space-x-4 mt-6 opacity-100">
      <CommonButtons label="Send Mail" className="px-2" onClick={onSendMail} disabled={disabled} />
      <CommonButtons label="Send Message" className="px-2" onClick={onSendMessage} disabled={disabled} />
      <div onClick={!disabled ? onDone : undefined}>
        <Print
          PrintData={{ ...printData, Paid: printData.Paid ?? 0, OSB: osb || 0 }}
          BtnName="Done"
          className="w-40 rounded-full"
        />
      </div>
    </div>
  );
}
